import compareSettings from '~/settings/compareSettings';
export const normalizeTag = (name) => name.trim().toLowerCase();
export const getExactMatchKey = (anchorTags, classification) => {
    const anchor = anchorTags.get(normalizeTag(classification.name));
    return anchor
        ? { rowKey: anchor.name, tabKey: anchor.name }
        : undefined;
};
export const getMatchingParentKey = (anchorTags, classification) => {
    var _a;
    if (!((_a = classification.parents) === null || _a === void 0 ? void 0 : _a.length))
        return;
    for (const parentClassification of classification.parents) {
        const anchor = anchorTags.get(normalizeTag(parentClassification.name));
        if (anchor) {
            return { rowKey: anchor.name, tabKey: classification.name };
        }
    }
};
export const getMatchingChildKeys = (anchorTags, classification) => {
    var _a;
    if (!((_a = classification.children) === null || _a === void 0 ? void 0 : _a.length))
        return;
    const matchingKeys = [];
    for (const childClassification of classification.children) {
        const anchor = anchorTags.get(normalizeTag(childClassification.name));
        if (anchor)
            matchingKeys.push({ rowKey: anchor.name, tabKey: classification.name });
    }
    return matchingKeys.length ? matchingKeys : undefined;
};
export const getExactMatchDescriptorInCategoryFamily = (anchorTags, classification) => {
    const matchingCategoryFamily = compareSettings.categoryFamilies.find(categoryFamily => {
        return categoryFamily.find(category => category === classification.category);
    });
    if (!matchingCategoryFamily)
        return;
    const matchingKeys = [];
    for (const category of matchingCategoryFamily) {
        const anchor = anchorTags.get(normalizeTag(`${category}: ${classification.descriptor}`));
        if (anchor) {
            matchingKeys.push({ rowKey: anchor.name, tabKey: anchor.name });
        }
    }
    return matchingKeys;
};
export const getDescriptorParentInCategoryFamily = (anchorTags, classification) => {
    var _a, _b;
    if (!((_a = classification.parents) === null || _a === void 0 ? void 0 : _a.length))
        return;
    const matchingCategoryFamily = compareSettings.categoryFamilies.find(categoryFamily => {
        return categoryFamily.find(category => category === classification.category);
    });
    if (!matchingCategoryFamily)
        return;
    const parentDescriptor = (_b = classification.parents[0].name.split(':')[1]) === null || _b === void 0 ? void 0 : _b.trim();
    const matchingKeys = [];
    for (const category of matchingCategoryFamily) {
        const anchor = anchorTags.get(normalizeTag(`${category}: ${parentDescriptor}`));
        if (anchor) {
            matchingKeys.push({
                rowKey: anchor.name,
                tabKey: `${category}: ${classification.descriptor}`,
            });
        }
    }
    return matchingKeys;
};
export const getDescriptorChildrenInCategoryFamily = (anchorTags, classification) => {
    var _a, _b;
    if (!((_a = classification.children) === null || _a === void 0 ? void 0 : _a.length))
        return;
    const matchingCategoryFamily = compareSettings.categoryFamilies.find(categoryFamily => {
        return categoryFamily.find(category => category === classification.category);
    });
    if (!matchingCategoryFamily)
        return;
    const matchingKeys = [];
    for (const category of matchingCategoryFamily) {
        for (const childClassification of classification.children) {
            const childDescriptor = (_b = childClassification.name.split(':')[1]) === null || _b === void 0 ? void 0 : _b.trim();
            const anchor = anchorTags.get(normalizeTag(`${category}: ${childDescriptor}`));
            if (anchor) {
                matchingKeys.push({
                    rowKey: anchor.name,
                    tabKey: `${category}: ${classification.descriptor}`,
                });
            }
        }
    }
    return matchingKeys;
};
